<template>

  <div>

  <el-alert show-icon type="info1" title="Please Note" :description="'Any ' + typeInv + ' items with a started date later than today, will not show until due date.'" />

  <data-table
    :table-ref="tableRef"
    :title="type + ' ' + typeInv + ' Items'"
    :url="sharerId ? urlSharer : urlSite"
    :show-search="false"
    :add-action="noAdd ? null : action"
    :add-props="noAdd ? null : addProps"
    :fields="fields">
 

    <template slot="actions" slot-scope="props">

      <el-row v-if="isManager('finance') && (!props.rowData.type.includes('Asset') && !props.rowData.type.includes('Fees'))" >

        <el-col :span="12">
          <site-invoice-action v-if="props.rowData.type.includes('Site') && !sharerId"  type="primary" :row-data="props.rowData" :site-id="siteData.id" :sharer-id="sharerId" :type="addProps.type" :table-ref="addProps.tableRef" />
          <site-invoice-action v-if="props.rowData.type.includes('Sharer') && sharerId"  type="primary" :row-data="props.rowData" :site-id="siteData.id" :sharer-id="sharerId" :type="addProps.type" :table-ref="addProps.tableRef" />
        </el-col>

        <el-col :span="12">
          <el-button v-if="props.rowData.type.includes('Site V.O.') && !sharerId" type="danger" size="mini" circle icon="fa fa-trash" @click="deleteInv(props.rowData)" />
          <el-button v-if="props.rowData.type.includes('Sharer V.O.') && sharerId" type="danger" size="mini" circle icon="fa fa-trash" @click="deleteInv(props.rowData)" />
          <el-button v-if="props.rowData.type === 'Sharer Item' && sharerId" type="danger" size="mini" circle icon="fa fa-trash" @click="deleteInv(props.rowData)" />
          <el-button v-if="props.rowData.type === 'Site Item' && !sharerId" type="danger" size="mini" circle icon="fa fa-trash"  @click="deleteInv(props.rowData)" />
        </el-col>

      </el-row>

    </template>

  </data-table>

  </div>

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'
import SiteInvoiceAction from '@/components/actions/SiteInvoiceAction'

export default {

  mixins: [SiteMixins],

  components: {
    SiteInvoiceAction
  },

  props: {
    siteData: {
      type: Object,
      required: true
    },

    sharerId: {
      type: Number,
      default: null
    },

    isVo: {
      type: Boolean,
      default: false
    }

  },


  methods: {
    editInv (row) {
      alert('edit: ' + row)
    },

    deleteInv (row) {

      this.deleteItem(this, row.id, this.deleteUrl,
        this.type + ' ' + this.typeInv + ' Item' + (row.description ? ': ' + row.description : ''),
        this.onDelete)

    },

    onDelete (response) {
      this.$events.fire(this.tableRef + '-refresh-table')
    }
  },

/*
  watch: {
    sharerId: function (id) {
      this.sh
    }
  },
*/

  data () {
    return {
      type: this.sharerId ? 'Sharer' : 'Site',
      typeInv: this.isVo ? 'V.O.' : 'Invoice',
      tableRef: (this.sharerId ? 'sharer' : 'site') + (this.isVo ? '-vo' : '') + '-invoice-table',

      localSite: this.siteData,
      action: SiteInvoiceAction,
      addProps: {
        siteId: this.siteData.id,
        sharerId: this.sharerId,
        type: (this.sharerId ? 'Sharer' : 'Site') + (this.isVo ? ' V.O.' : '') + ' Item',
        tableRef: (this.sharerId ? 'sharer' : 'site') + (this.isVo ? '-vo' : '') + '-invoice-table'
      },

      noAdd: !this.isManager('finance|management'),
      urlSite: 'finance/invoice/site/' + this.siteData.id + (this.isVo ? '/vo' : ''),
      urlSharer: 'finance/invoice/sharer/' + this.siteData.id + '/' + this.sharerId + (this.isVo ? '/vo' : ''),
      deleteUrl: 'finance/invoice/' + (this.sharerId ? 'sharers' : 'sites'),

      fields: [
        {
          name: '__sequence',
          title: '#'
        },
        {
          name: 'type',
          title: 'Type',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'billingStart',
          title: 'Start',
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'billingPeriod',
          title: 'Frequency',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'description',
          title: 'Desc.'
        },
        {
          name: 'quantity',
          title: 'Qty.',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'amount',
          title: 'Amount',
          callback: this.formatNumber,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'discount',
          title: 'Disc.',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'totalDiscount',
          title: 'Total Disc.',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'tax',
          title: 'Tax',
          callback: this.formatNumber,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'subTotal',
          title: 'Sub-Total',
          callback: this.formatNumber,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'total',
          title: 'TOTAL',
          callback: this.formatNumber,
          titleClass: 'text-primary',
          dataClass: 'text-primary'
        },
        {
          name: 'lastBilling',
          title: 'Last Bill',
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: '__slot:actions'
        }
      ]
    }
  }

}
</script>
